export default __webpack_public_path__ + "static/media/snare.6ca4e2c6.ogg";